import { Button, Stack } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { ISearchCommunityFormBodyProps } from '~/components/forms/SearchCommunityForm';
import type { IContainerProps } from '~/components/utils/Container';
import type { IApiCrowdSearchFiltersRequestBody } from '~/lib/api/modules/Crowd';
import { SearchCommunityFormBody } from '~/components/forms/SearchCommunityForm';
import { Aside } from '~/components/molecules/Aside';

export type ISearchCommunityAsideProps = IContainerProps &
  ISearchCommunityFormBodyProps & {
    children?: React.ReactNode;
    loading?: boolean;
    onReset?: () => void;
    filter?: IApiCrowdSearchFiltersRequestBody;
  };

export const SearchCommunityAside: React.FC<ISearchCommunityAsideProps> = (
  props,
) => {
  const { sx, form, children, loading, onReset, ...other } = props;
  const { t } = useTranslation();

  return (
    <Aside sx={sx} headline={t('SearchCommunityAside.title')}>
      <SearchCommunityFormBody form={form} {...other}>
        <Stack horizontal gap={2}>
          <Button type="submit" loading={loading}>
            {t('common.search')}
          </Button>

          {onReset && (
            <Button
              type="reset"
              variant="text"
              disabled={loading}
              onClick={onReset}
            >
              {t('common.reset')}
            </Button>
          )}
        </Stack>
      </SearchCommunityFormBody>

      {children}
    </Aside>
  );
};
